import { useEffect, useState } from "react";

export function useHasKeyboard(): boolean {
  const [hasKeyboard, setHasKeyboard] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window === "undefined" || typeof navigator === "undefined")
      return;

    const detectKeyboard = () => {
      const hasTouchScreen =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        // Some browsers use msMaxTouchPoints
        ((navigator as Navigator & { msMaxTouchPoints?: number })
          .msMaxTouchPoints ?? 0) > 0;

      const hasPointerEvents = window.matchMedia("(pointer: fine)").matches;
      const hasHoverCapability = window.matchMedia("(hover: hover)").matches;

      const likelyHasKeyboard =
        (hasPointerEvents && hasHoverCapability) || !hasTouchScreen;

      setHasKeyboard(likelyHasKeyboard);
    };

    detectKeyboard();

    const pointerMediaQuery = window.matchMedia("(pointer: fine)");
    const hoverMediaQuery = window.matchMedia("(hover: hover)");

    const handleMediaQueryChange = () => detectKeyboard();

    if (pointerMediaQuery.addEventListener) {
      pointerMediaQuery.addEventListener("change", handleMediaQueryChange);
      hoverMediaQuery.addEventListener("change", handleMediaQueryChange);
    }

    return () => {
      if (pointerMediaQuery.removeEventListener) {
        pointerMediaQuery.removeEventListener("change", handleMediaQueryChange);
        hoverMediaQuery.removeEventListener("change", handleMediaQueryChange);
      }
    };
  }, []);

  return hasKeyboard;
}
